let token = 'token'
let user_permissions = "user_permissions"

const setItem = (key, value) => {
  let data = typeof value == 'object' ? JSON.stringify(value) : value
  localStorage.setItem(key, data)
}

const getItem = key => {
  let data = JSON.parse(localStorage.getItem(key))
  return data
}

const setToken = accessToken => {
  localStorage.setItem(token, accessToken)
}

const getToken = () => {
  const accessToken = getItem("user")?.token || null
  return accessToken
}

const getPermissions = () => {
  const accessToken = localStorage.getItem(token)
  return accessToken
}

const cleanToken = () => {
  localStorage.removeItem(token)
}

const cleanStorage = () => {
  localStorage.clear()
}

export {
  setItem,
  getItem,
  setToken,
  cleanToken,
  cleanStorage,
  getToken,
  getPermissions
}
